// extracted by mini-css-extract-plugin
export default {"task":"BwXJoKf3Uzma1llqqkjS"};